import { ApolloClient, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { InMemoryCache } from '@apollo/client/cache'
import { relayStylePagination } from '@apollo/client/utilities'

import CsrfToken from './utils/csrf'

const credentials = 'same-origin'
const headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': CsrfToken()
}
const dataIdFromObject = object => {
  const type = object.__typename || 'unknown-type'
  let id = object.slug || object.uuid || object.iid || object.tag || object.id
  return id ? `${type}:${id}` : null
}

const client = new ApolloClient({
  defaultOptions: {
    name: 'private'
  },
  link: from([
    onError(({ graphQLErrors }) => {
      if (graphQLErrors?.find(({ message }) => message === 'Invalid Session'))
        window.location = `/invalid-session?redirect_to=${window.location.pathname}`
    }),
    new BatchHttpLink({
      uri: '/graphql',
      credentials,
      headers,
      batchMax: 3
    })
  ]),
  cache: new InMemoryCache({
    dataIdFromObject,
    typePolicies: {
      Organisation: {
        fields: {
          teams: {
            merge(existing, incoming) {
              return incoming
            }
          },
          subscription: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      },
      Subscription: {
        fields: {
          customer: {
            merge(existing, incoming) {
              return incoming
            }
          },
          paymentMethod: {
            merge(existing, incoming) {
              return incoming
            }
          },
          plan: {
            merge(existing, incoming) {
              return incoming
            }
          },
          testAllocation: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      },
      Membership: {
        fields: {
          teams: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      },
      Team: {
        fields: {
          site: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      },
      Site: {
        fields: {
          pagesList: relayStylePagination(),
          snapshotsList: relayStylePagination(),
          testProfiles: {
            merge(existing, incoming) {
              return incoming
            }
          },
          headers: {
            merge(existing, incoming) {
              return incoming
            }
          },
          cookies: {
            merge(existing, incoming) {
              return incoming
            }
          },
          agentSettings: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      },
      TestProfile: {
        fields: {
          device: {
            merge(existing, incoming) {
              return incoming
            }
          }
        }
      }
    }
  })
})

export default client
